

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

#antimalware-on-execute-virus-control-default-action-field {
  --form-field-label-width: 313px;
}

.checkbox-with-input .checkbox-width {
  width: 297px;
}

#antimalware-on-execute-ransomware-restore-mode-field {
  margin-bottom: 120px;
}
